import { Injectable } from "@angular/core";
import { BaseService } from "../../core";
import { environment } from "environments/environment";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { TrilhaModulosSlimResponse, TrilhaRequest, TrilhaResponse } from "app/shared/models/ei-models";

@Injectable({
  providedIn: 'root'
})
export class TrilhaService extends BaseService {
  private controllerEndpoint = environment.urlEdducaImobApi.concat('api/Trilha/');

  constructor(private httpClient: HttpClient) {
    super();
  }

  listar(): Observable<TrilhaResponse[]> {
    return this.httpClient.get<TrilhaResponse[]>(
      this.controllerEndpoint.concat('Listar'), 
      { headers: this.getHeader(true) }
    );
  }

  obterModulosEAulasSlim(trilhaId: number, moduloInicialId?: number): Observable<TrilhaModulosSlimResponse> {
    let params = new HttpParams();
    if (moduloInicialId) params = params.set('moduloInicialId', moduloInicialId.toString());
    return this.httpClient.get<TrilhaModulosSlimResponse>(
      this.controllerEndpoint.concat(`${trilhaId}/modulos-aulas-slim`),
      { headers: this.getHeader(true), params }
    );
  }

  criar(payload: TrilhaRequest): Observable<void> {
    return this.httpClient.post<void>(
      this.controllerEndpoint.concat('Criar'), 
      payload, 
      { headers: this.getHeader(true) }
    );
  }

  atualizar(payload: TrilhaRequest): Observable<void> {
    return this.httpClient.put<void>(
      this.controllerEndpoint.concat('Atualizar/', payload.id.toString()), 
      payload, 
      { headers: this.getHeader(true) }
    );
  }

  remover(id: number): Observable<void> {
    return this.httpClient.delete<void>(
      this.controllerEndpoint.concat('Remover/', id.toString()), 
      { headers: this.getHeader(true) }
    );
  }
}